import MiniAppContainer from "./MiniAppContainer";
import { useDispatch, useSelector } from "react-redux";
import useUserData from "../../hooks/useUserData";
import { useEffect } from "react";
import { setSelectedPortfolioExchange } from "../../redux/exchange/actions";
import styles from "../../styles/Components/mini-app/MiniPortfolio.module.css";
import Avatar from "react-avatar";
import capitalize from "antd/es/_util/capitalize";
import MinimalCard from "./MinimalCard";
import useExchangePortfolioInfo from "../../hooks/exchange/useExchangePortfolioInfo";
import ExchangeBalanceInfo from "../exchange-portfolio/ExchangeBalanceInfo";
import CurrentAccountInfo from "./mini-portfolio/CurrentAccountInfo";
import useFetchExchanges from "../../hooks/api/useFetchExchanges";
import ExchangeAccountAssets from "./mini-portfolio/ExchangeAccountAssets";

function MiniPortfolio() {
  const {
    exchangeState: { selectedPortfolioExchange },
    main: { userData },
    profile: { profileData },
  } = useSelector((state) => state);

  const { balanceLoading, portfolioLoading, balanceChange, totalBalance } =
    useExchangePortfolioInfo();

  const {
    "7d": { percent: weeklyChangePercentage, usd: weeklyChangeUsd },
    "24h": { percent: dailyChangePercentage, usd: dailyChangeUsd },
  } = balanceChange;

  const { email, username } = useUserData();

  const dispatch = useDispatch();

  useFetchExchanges();

  useEffect(() => {
    if (!selectedPortfolioExchange && email) {
      const targetExchange = profileData?.bot_active_exchange || "cryptocrispy";

      dispatch(setSelectedPortfolioExchange(targetExchange, username, email));
    }
  }, [selectedPortfolioExchange, profileData, email]);

  return (
    <MiniAppContainer>
      <MinimalCard customClassName={styles.profileBox}>
        <div className={styles.header}>
          <div className={styles.username}>
            <div className={styles.profileImage}>
              {profileData?.avatar_url ? (
                <img
                  className={styles.profileImg}
                  src={profileData?.avatar_url}
                  alt="profile image"
                />
              ) : (
                <Avatar name={username} size="100%" round={true} />
              )}
            </div>
            <h4 className={styles.welcome}>
              Hi{username ? `, ${capitalize(username)}` : null}
            </h4>
          </div>
        </div>

        <ExchangeBalanceInfo className={styles.balanceInfo} />
      </MinimalCard>

      <CurrentAccountInfo />

      <ExchangeAccountAssets />
    </MiniAppContainer>
  );
}

export default MiniPortfolio;
